import { apiClient } from "../config";

async function getImportStatusDetail(id: string) {
  const res = await apiClient.get(`/admin/imports/${id}/status-detail`);
  return res.data;
}

export default getImportStatusDetail;

